import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
//import VueHtmlToPaper from 'vue-html-to-paper';
import "core-js/stable";
import "regenerator-runtime/runtime";
import axios from "axios";
import VueHtml2Canvas from 'vue-html2canvas';
import VueBarcodeScanner from 'vue-barcode-scanner'
if(store.state.auth.status.loggedIn){
  let storage = JSON.parse(localStorage.getItem('user'));
  let access_token= storage.token
  axios.defaults.headers.common["Authorization"] = `Token ${access_token}`
}
Vue.use(VueSkycons, {
  color: "#1e88e5",
});

Vue.use(VueHtml2Canvas);
Vue.use(VueBarcodeScanner)

Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
